module.exports = __webpack_public_path__ + "img/reload.db212912.svg";